// extracted by mini-css-extract-plugin
module.exports = {"block":"Quantity_block__3Svo0","time":"Quantity_time__3Ukem","input":"Quantity_input__1J3ha","decrease":"Quantity_decrease__3TBiy","increase":"Quantity_increase__1SXpM"};